import React from 'react';
import { Modal, Spin, Typography } from 'antd';
import { ActionButton, StyledTable } from '../styled';

const { Text } = Typography;

const SelectVolunteerModal = ({
  selectVolunteerModal,
  onClose,
  onCreateUserFromRegistration
}) => {
  return (
    <Modal
      title="Add Volunteer from Approved Registrations"
      open={selectVolunteerModal.visible}
      onCancel={onClose}
      footer={[
        <ActionButton key="close" onClick={onClose}>
          Close
        </ActionButton>
      ]}
      width={800}
    >
      {selectVolunteerModal.loading ? (
        <div style={{ textAlign: 'center', padding: '40px' }}>
          <Spin size="large" />
          <div style={{ marginTop: 16 }}>Loading approved registrations...</div>
        </div>
      ) : selectVolunteerModal.approvedRegistrations.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '40px', color: '#8c8c8c' }}>
          <Text type="secondary">
            No approved registrations found. Approve volunteer registrations first in the Registrations tab.
          </Text>
        </div>
      ) : (
        <div>
          <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
            Select an approved registration to create a volunteer account. The volunteer will receive login credentials.
          </Text>
          <StyledTable
            dataSource={selectVolunteerModal.approvedRegistrations}
            rowKey="_id"
            size="small"
            pagination={false}
            scroll={{ y: 400 }}
            columns={[
              {
                title: 'Name',
                dataIndex: 'fullName',
                key: 'fullName',
                render: (text) => <span style={{ fontWeight: 500 }}>{text}</span>
              },
              {
                title: 'Email',
                dataIndex: 'email',
                key: 'email'
              },
              {
                title: 'Location',
                key: 'location',
                render: (_, record) => {
                  if (record.preferredCity && record.preferredState) {
                    return `${record.preferredCity}, ${record.preferredState}`;
                  } else if (record.preferredCity) {
                    return record.preferredCity;
                  }
                  return record.isGeneralVolunteer ? 'Any Location' : '-';
                }
              },
              {
                title: 'Volunteer Area',
                dataIndex: 'volunteerArea',
                key: 'volunteerArea'
              },
              {
                title: 'Action',
                key: 'action',
                width: 120,
                render: (_, record) => (
                  <button
                    type="button"
                    disabled={selectVolunteerModal.creatingUserId === record._id}
                    onClick={() => onCreateUserFromRegistration(record)}
                    style={{
                      backgroundColor: '#1890ff',
                      border: '1px solid #1890ff',
                      color: 'white',
                      fontSize: '11px',
                      padding: '2px 8px',
                      height: '22px',
                      borderRadius: '4px',
                      cursor: selectVolunteerModal.creatingUserId === record._id ? 'not-allowed' : 'pointer',
                      opacity: selectVolunteerModal.creatingUserId === record._id ? 0.6 : 1
                    }}
                  >
                    {selectVolunteerModal.creatingUserId === record._id ? 'Creating...' : 'Create Account'}
                  </button>
                )
              }
            ]}
          />
        </div>
      )}
    </Modal>
  );
};

export default SelectVolunteerModal;
